import { render, staticRenderFns } from "./ViewEditComponent.vue?vue&type=template&id=a3fd0a34"
import script from "./ViewEditComponent.vue?vue&type=script&lang=js"
export * from "./ViewEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports